import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// AutomaticMessages Redux States
import {
  GET_AUTOMATIC_MESSAGES,
  GET_AUTOMATIC_MESSAGE,
  CREATE_AUTOMATIC_MESSAGE,
  EDIT_AUTOMATIC_MESSAGE,
  DELETE_AUTOMATIC_MESSAGE,
} from "./actionTypes";
import {
  setAutomaticMessages,
  apiError,
  setAutomaticMessage,
  createAutomaticMessageSuccess,
  editAutomaticMessageSuccess,
  deleteAutomaticMessageSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getAutomaticMessages({ payload: { page, qnt, name } }) {
  try {
    const response = yield call(
      axios.get,
      `/automatic-messages?${
        (page ? `page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setAutomaticMessages(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createAutomaticMessage({ payload: { newAutomaticMessageValues } }) {
  try {
    const response = yield call(axios.post, `/automatic-messages`, newAutomaticMessageValues);
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message;
      yield put(createAutomaticMessageSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getAutomaticMessage({ payload: { idAutomaticMessage, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/automatic-messages?${
        (idAutomaticMessage ? `id=${idAutomaticMessage}` : "") + (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setAutomaticMessage(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editAutomaticMessage({ payload: { idAutomaticMessage, newAutomaticMessageValues } }) {
  try {
    const response = yield call(
      axios.patch,
      `/automatic-messages?${idAutomaticMessage ? `id=${idAutomaticMessage}` : ""}`,
      newAutomaticMessageValues
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(editAutomaticMessageSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteAutomaticMessage({ payload: { idAutomaticMessage } }) {
  try {
    const response = yield call(
      axios.delete,
      `/automatic-messages${idAutomaticMessage ? `?id=${idAutomaticMessage}` : ""}`
    );
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteAutomaticMessageSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
export function* watchAutomaticMessage() {
  yield takeEvery(GET_AUTOMATIC_MESSAGES, getAutomaticMessages);
}
export function* watchGetAutomaticMessage() {
  yield takeEvery(GET_AUTOMATIC_MESSAGE, getAutomaticMessage);
}
export function* watchCreateAutomaticMessage() {
  yield takeEvery(CREATE_AUTOMATIC_MESSAGE, createAutomaticMessage);
}
export function* watchEditAutomaticMessage() {
  yield takeEvery(EDIT_AUTOMATIC_MESSAGE, editAutomaticMessage);
}
export function* watchDeleteAutomaticMessage() {
  yield takeEvery(DELETE_AUTOMATIC_MESSAGE, deleteAutomaticMessage);
}
function* authSaga() {
  yield all([
    fork(watchAutomaticMessage),
    fork(watchGetAutomaticMessage),
    fork(watchCreateAutomaticMessage),
    fork(watchEditAutomaticMessage),
    fork(watchDeleteAutomaticMessage),
  ]);
}

export default authSaga;
